/**
 * List of apache directives to access web services
 */
export const WC_WS = {
  wc: "ussiwws"
};

/**
 * Workers' Compensation web services
 */
export const WRK_URL = {
  X: WC_WS.wc + "/wwc001.pgm"
};
